
import TeamPageComponent from './team-page-component.vue'

export * from './components';

export {
    TeamPageComponent
}